<div class="back-btn" (click)="onBackButtonClick()">
<div
  class="parental-pin-container horizontal-center"
  (click)="disabled($event)"
  (mousedown)="disabled($event)"
  (mouseup)="disabled($event)"
>
  <app-numeric-keypad
    (keyPress)="onKeyPress($event)"
    (backspace)="onBackspace()"
    (focusRight)="focusPinInputAction()"
  ></app-numeric-keypad>
  <app-pin-input
    [pin]="pin"
    (pinSubmitted)="onPinSubmitted($event)"
    (pinCleared)="onPinCleared()"
    [errorMessage]="errorMessage"
  ></app-pin-input>
</div>
